
import CheckboxField from '@/components/processing_steps/commons/fields/CheckboxField.vue'
import FormContainer from '@/components/processing_steps/commons/forms/FormContainer.vue'
import { Component, Prop, Vue } from 'vue-property-decorator'
import CompletitionLayout from '@/components/processing_steps/commons/CompletitionLayout.vue'
import { ISummaryItem } from '@/types/processingSteps'

@Component({
  components: {
    FormContainer,
    CheckboxField,
    CompletitionLayout
  }
})
export default class FundingScopeIsPublicForm extends Vue {
  @Prop() isComplete!: boolean
  @Prop() summaryItems!: ISummaryItem[]
  @Prop() isArchive!: boolean

  get statusTitle (): string {
    return this.isArchive
      ? this.$gettext('The funding scope is archived')
      : this.$gettext('The funding scope is published')
  }

  get statusExplanation (): string {
    return this.isArchive
      ? this.$gettext('This support area is archived. <br> Next step: Create a project or an additional funding area')
      : this.$gettext('This support area is complete. <br> Next step: Create a project or an additional funding area')
  }
}
